module.exports = __webpack_public_path__ + "img/zzj2.a2bb46fd.png";